import React from 'react';

import { ClickableIcon } from '~components';
import { faPenToSquare, faTrash } from '~components/icon';

import { CarePlanServiceLine } from '~clients/models';

interface ComponentProps {
  line: CarePlanServiceLine;
  onEdit: (line: CarePlanServiceLine) => void;
  onDelete: (line: CarePlanServiceLine) => void;
  /** Disables the delete action while a mutation is in flight. */
  disabled?: boolean;
}

/** Right-aligned edit + delete actions for a List-view row. Separate component so
 *  serviceLinesList.ts stays JSX-free. */
const ServiceLineActions: React.FC<ComponentProps> = ({ line, onEdit, onDelete, disabled = false }) => (
  <div className="d-flex justify-content-end align-items-center gap-2">
    <ClickableIcon
      id={`care-plan-service-list-edit-${line.id}`}
      dataCy={`care-plan-service-list-edit-${line.id}`}
      icon={faPenToSquare}
      color="secondary"
      toolTip="Edit service"
      ariaLabel="Edit service"
      onClick={() => onEdit(line)}
    />
    <ClickableIcon
      id={`care-plan-service-list-delete-${line.id}`}
      dataCy={`care-plan-service-list-delete-${line.id}`}
      icon={faTrash}
      color="danger"
      disabled={disabled}
      toolTip="Delete service"
      ariaLabel="Delete service"
      onClick={() => onDelete(line)}
    />
  </div>
);

export default ServiceLineActions;
